import { AfterViewInit, Component, ElementRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FriendlycaptchaService } from '../../service/friendlycaptcha.service';
import { SettingsService } from '../../service/settings.service';
import { WidgetInstance } from 'friendly-challenge';
import { FriendlycaptchaService as FriendlycaptchaServiceMock } from '../../../test/mocks/friendlycaptcha.service';

@Component({
  selector: 'app-friendlycaptcha-widget',
  templateUrl: './friendlycaptcha-widget.component.html',
  styleUrls: ['./friendlycaptcha-widget.component.scss']
})
export class FriendlycaptchaWidgetComponent implements OnInit, AfterViewInit {

  @Input()
  idprefix: string;

  @ViewChild('frccaptcha', { static: false })
  friendlyCaptcha: ElementRef<HTMLElement>;

  widget: WidgetInstance;

  friendlycaptchaService: FriendlycaptchaService;

  constructor(private injector: Injector, public settingsService: SettingsService) {
    if (this.settingsService.settings.FriendlycaptchaEnabled) {
      this.friendlycaptchaService = this.injector.get(FriendlycaptchaService);
    } else {
      this.friendlycaptchaService = this.injector.get(FriendlycaptchaServiceMock);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.widget = this.friendlycaptchaService.createWidget(this.friendlyCaptcha.nativeElement);
  }

  getSolution(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.widget = this.friendlycaptchaService.createWidget(this.friendlyCaptcha.nativeElement,
        (solution): void => {
          resolve(solution);
        },
        (error): void => reject(error));
      this.widget.start();
    });
  }
}
